var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5979 3.32394C8.82011 3.38028 6.5 7 6 11C6.99048 7.33803 12.1446 7.26761 14.5979 7.69014V10.0845L19 5.57747L14.5979 1V3.32394Z",
  stroke: "#C8CACF",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 2H1V16H14V12.36",
  stroke: "#C8CACF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgExternalIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNC41OTc5IDMuMzIzOTRDOC44MjAxMSAzLjM4MDI4IDYuNSA3IDYgMTFDNi45OTA0OCA3LjMzODAzIDEyLjE0NDYgNy4yNjc2MSAxNC41OTc5IDcuNjkwMTRWMTAuMDg0NUwxOSA1LjU3NzQ3TDE0LjU5NzkgMVYzLjMyMzk0WiIgc3Ryb2tlPSIjQzhDQUNGIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNNy41IDJIMVYxNkgxNFYxMi4zNiIgc3Ryb2tlPSIjQzhDQUNGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==";